export const frontPageHeader = 'Your tires are the first and only contact with the road, so it\u0027s important to choose the right set. Our Tire Finder tool makes it quick and easy to find tires for any vehicle. Use the drop-down menus to select your vehicle information and navigate your search. Once you\u0027ve selected your new tires, the Certified Service expert technicians can handle all of your tire needs at your scheduled appointment\u2014it\u0027s that simple.';
export const FRONTPAGENAME = 'Find New Tires';
export const findTires = 'Find Tire Pricing';
export const frontPageNameFor = 'Find New Tires For';
export const searchByVehicle = 'SEARCH BY VEHICLE';
export const YEAR = 'Year';
export const MAKE = 'Make';
export const MODEL = 'Model';
export const TRIM = 'Trim';
export const TIRESIZE = 'Tire Size';
export const ZIPCODE = 'Zip Code';
export const selectYear = 'Select Year';
export const selectMake = 'Select Make';
export const selectModel = 'Select Model';
export const selectTire = 'Select Tire';
export const selectSize = 'Select Size';
export const searchTires = 'Search For Tires';
export const updateSearch = 'Update Search Results';
export const pleaseSelectOption = 'Please select an option for all required fields.';
export const close = 'CLOSE';
export const tooManyTires = 'Too Many Tires In Cart';
export const tooManyTiresMessage = 'There can only be 3 tires in the cart you have selected ';
export const tooManyTiresRemove = 'Please Remove ';
export const tireWidth = 'TIRE WIDTH';
export const aspectRatio = 'ASPECT RATIO';
export const diameter = 'DIAMETER';
export const selectTireWidth = 'Select Tire Width';
export const selectAspectRatio = 'Select Aspect Ratio';
export const selectDiameter = 'Select Diameter';
export const disclaimer = 'DISCLAIMER';
export const disclaimerMessage = 'Please note that tires may not fit if we don\u0027t have your vehicle information correct.';
export const showing = 'Showing';
export const of = 'of';
export const tires = 'Tires';
export const showAll = 'Show All';
export const paging = 'Paging';
export const sortBy = 'Sort By';
export const tiresToCompare = 'Tires to Compare';
export const viewCart = 'View Cart';
export const compare = 'Compare';
export const type = 'Type';
export const load = 'Load';
export const speed = 'Speed';
export const loadRange = 'Load Range';
export const size = 'Size';
export const sidewall = 'Sidewall';
export const warranty = 'Warranty';
export const origEquipment = 'Original Equipment';
export const showDetails = 'Show Additional Details';
export const hideDetails = 'Hide Additional Details';
export const getQuote = 'Get Quote';
export const calldealer1 = 'Contact Dealership for Pricing';
export const calldealer2 = 'Call Dealership';
export const compareTire = 'Compare Tire';
export const availOffers = 'Available Offers';
export const eachCaps = 'EA';
export const select = 'Select';
export const addDetails = 'Additional Details';
export const gmPartNumber = 'GM Part Number';
export const replaceFound = 'Replacement Tire\u0028s\u0029 Found';
export const replaceTire = 'Replacement Tire';
export const loadingData = 'Loading Data...';
export const availRebates = 'Available Promotions';
export const promoTitle = 'Promo Title';
export const offerType = 'Offer Type';
export const effDate = 'Effective Date';
export const expDate = 'Expiration Date';
export const pmgTitle = 'PMG Offer Title';
export const pmgType = 'PMG Offer Type';
export const rebateAmount = 'Rebate amount\u002Ffour tires';
export const product = 'Product';
export const quantity = 'Quantity';
export const remove = 'Remove';
export const findAnotherTire = 'Find Another Tire';
export const requestQuote = 'Request Quote';
export const pleasePrint = 'Please Print This Page For Your Records';
export const thirtyDay = '30-Day';
export const priceCaps = 'PRICE';
export const matchCaps = 'MATCH';
export const onCaps = 'ON';
export const tiresCaps = 'TIRES';
export const thirtyDayMessageOne = 'Buy select tires and if you find a better price within 30 days of purchase,' +
    ' we\'ll refund the difference.';
export const thirtyDayMessageTwo = 'ELIGIBLE TIRE BRANDS FOR TIRE DEALS\u003A BFGoodrich, Bridgestone, Continental, Dunlop, Firestone, General, Goodyear, Hankook, Kelly, Michelin, Pirelli, and Uniroyal';
export const thirtyDayMessageThree = 'Ad, written estimate, or Internet quote for identical tire\u0028s\u0029 from a competing tire retailer\u2215installer located within 100 miles of the dealer required during guarantee period for price match. Offer valid at participating dealers only.';
export const offerDetails = 'Offer Details';
export const offerBegins = 'Offer Begins';
export const offerEnds = 'Offer Ends';
export const noOffers = 'N/A';
export const productCaps = 'PRODUCT';
export const quantityCaps = 'QUANTITY';
export const totalCaps = 'TOTAL';
export const selectCartMessagePartOne = 'You\'re almost there! Review your options selected below. If you\u0027ve' +
    ' found the right tires, then you\u0027re ready to schedule an appointment';
export const selectCartMessagePartTwo = ' with a Certified Service expert technician. Tires are subject to availability.';
export const each = ' ea';
export const installation = 'Installation';
export const clickAddService = 'Click To Add Additional Services';
export const otherInformation = 'Other Information';
export const subTotal = 'Sub Total';
export const salesTax = 'Sales Tax \u0028May Apply\u0029';
export const total = 'Total';
export const totalNoMir = 'Total Without Mail\u002Din Rebate';
export const totalWithMir = 'Total With Mail\u002Din Rebate';
export const scheduleAppt = 'Schedule Appointment';
export const cobaltAppt = 'Cobalt Appointment Service';
export const please = 'Please';
export const print = 'Print';
export const records = 'This Page For Your Records';
export const recentlyViewed = 'Recently Viewed';
export const RAQMessageOne = 'Not seeing a price for your tires? No problem. Just fill out the information below and our service department will contact you with pricing information.';
export const RAQThankYou = 'Thank you for your interest in GM vehicles. U.S. residents please fill out the required fields below. Non U.S. residents please visit your country specific GM website and\u002For your local dealer for further information.';
export const RAQConsent = 'By providing my contact information below, I consent that GM and\u002For a GM dealer can' +
    ' contact me with any GM offers and GM product information.';
export const contactCaps = 'CONTACT INFORMATION';
export const firstNameCaps = 'FIRST NAME';
export const lastNameCaps = 'LAST NAME';
export const phoneNumber = 'PHONE NUMBER';
export const required = 'Required';
export const streetAddressCaps = 'STREET ADDRESS';
export const cityCaps = 'CITY';
export const stateCaps = 'STATE';
export const zipCodeCaps = 'ZIP CODE';
export const emailAddress = 'EMAIL ADDRESS';
export const prefContactCaps = 'PREFERRED CONTACT METHOD';
export const selectState = 'Select State';
export const vehicleInfoCaps = 'VEHICLE INFORMATION';
export const additionalServicesCaps = 'ADDITIONAL SERVICES';
export const yearCaps = 'YEAR';
export const makeCaps = 'MAKE';
export const modelCaps = 'MODEL';
export const vinNumberCaps = 'VIN NUMBER';
export const mileageCaps = 'MILEAGE';
export const optionalMessageCaps = 'MESSAGE\u0028OPTIONAL\u0029';
export const otherServiceCaps = 'OTHER\u0028MAX 200 CHARACTERS\u0029';
export const tireQuotesReqCaps = 'TIRE QUOTES REQUESTED';
export const threeMax = ' \u00283 Quotes Maximum\u0029';
export const addAnotherQuote = 'Add Another Tire Quote';
export const submitRequestQuote = 'Submit Request for Quote';
export const hoursOfOperation = 'Hours Of Operation';
export const servicePhone = 'Service Phone';
export const website = 'Website';
export const directions = 'Get Directions';
export const thankYouMessage = 'Thank you for submitting a request for a quote. Someone will respond to your request as soon as possible!';
export const ok = 'OK';
export const upTo = 'UP TO';
export const hundredMailInRebateCaps = '\u0024100 MAIL\u002DIN REBATE';
export const debitCardCaps = '\u0028DEBIT CARD\u0029';
export const onSelectTiresCaps = 'ON SELECT TIRES';
export const hundredMailInRebate = '\u0024100 Mail\u002DIn Rebate \u0028debit card\u0029';
export const mirMessageOne = 'on a set of four tires from these select brands\u003A Bridgestone, Continental, Goodyear, Hankook, and Pirelli';
export const seventyMailInRebate = '\u002470 Mail\u002DIn Rebate \u0028debit card\u0029';
export const mirMessageTwo = 'on a set of four tires from this select brand\u003A Michelin';
export const fiftyMailInRebate = '\u002450 Mail\u002DIn Rebate \u0028debit card\u0029';
export const mirMessageThree = 'on a set of four tires from these select brands\u003A BFGoodrich, Dunlop, Firestone, and General';
export const seeDealerMessage = 'See participating U.S. dealer for details and rebate form, which must be postmarked by 12\u002F31\u002F16. Allow 6 to 8 weeks for delivery of debit card. Offer ends 11\u002F30\u002F16.';
export const returnCertifiedService = 'Return to Certified Service';
export const returnBuick = 'Return to Buick Certified Service';
export const returnGMC = 'Return to GMC Certified Service';
export const returnCadillac = 'Return to Cadillac Certified Service';
export const returnChevrolet = 'Return to Chevrolet Certified Service';
export const selectedDealer = 'Selected Dealer';
export const changeDealer = 'Change Dealer';
export const easyMessage = 'It\u0027s easy to find the best local tire prices. Simply select a location to see tire pricing information';
export const searchBy = 'Search By';
export const zipCodeOrCityState = 'Zip Code or City, State';
export const name = 'Name';
export const search = 'Search';
export const dealersWereFound = 'Dealers Were Found';
export const noDealersFound = 'No dealers found. Please try a different search or check your search term and try again';
export const noDealersFoundNearZip = 'No Dealers Found Near';
export const selectDealerPricing = 'Select Dealer for Pricing';
export const selectDealerQuote = 'Select Dealer for Quote';
export const locateADealer = 'LOCATE A DEALER TO VIEW PRICING';
export const thankYouRequestSubmittedOne = 'Thank You! Your request has been submitted. Our service department at ';
export const thankYouRequestSubmittedTwo = ' will respond to your request as soon as possible. When you stop in for your scheduled appointment, our Certified Service expert technicians will handle all of your tire needs';
export const feelFree = 'Feel free to browse for';
export const filterResults = 'Filter Results';
export const brands = 'Brands';
export const price = 'Price';
export const speedRatings = 'Speed Ratings';
export const classifications = 'Classifications';
export const loads = 'Loads';
export const tireTypes = 'Tire Types';
export const clearFilters = 'Clear Filters';
export const pricingUnavailable = 'Pricing Unavailable';
export const mileageWarranty = 'Mileage Warranty';
export const warning = 'Warning';
export const warningMessage = 'Your cart and recently viewed tires will be cleared if you change vehicles. Select \u0022Yes\u0022 to continue or \u0022No\u0022 to keep your current vehicle, cart and recently viewed tires list.';
export const yes = 'Yes';
export const no = 'No';
export const trimOptions = 'Trim Options';
export const hereAtGm = 'Here at GM we want to help you find tires!';
export const availModels = 'Available models';
export const confirmTiresPartOne = 'Confirm tires and options selected. Then schedule appointment at ';
export const confirmTiresPartTwo = 'Tires are subject to availablity';
export const viewLargerPhoto = 'View Larger Photo';
export const selectQuantity = 'Select Quantity';
export const priceLowToHigh = 'Price: Low to High';
export const priceHighToLow = 'Price: High to Low';
export const brandAToZ = 'Brand: A to Z';
export const brandZToA = 'Brand: Z to A';
export const underOneHundred = 'Under $100';
export const underThreeHundred = 'Under $300';
export const underFiveHundred = 'Under $500"';
export const SPECIFICTIRES = 'Find tires specific to your vehicle';
export const ENTERZIP = 'Enter Zip Code for pricing options';
export const HOWTO = 'How to find tire size';
export const CURRENT = 'Use current location';
export const FINDTIRES = "Find Tires";
export const DEFAULT_OFFER_TITLE = "30 Day Price Match on select tires" + String.fromCharCode(8225);
export const DEFAULT_OFFER_DESCRIPTION = "Eligible Tire Brands: BFGoodrich, Bridgestone, Continental, Dunlop, Firestone, General, Goodyear, Hankook, Kelly, Michelin, Pirelli and Uniroyal.";
export const DEFAULT_OFFER_DISCLAIMER = String.fromCharCode(8225) + "Provide us with a better eligible price at the time of purchase, and we’ll match it. Find a better price within 30 days of the purchase, and we’ll refund the difference. Ad, written estimate, or internet quote for identical tire(s) from a competing tire retailer/installer located within 100 miles of the dealer required during guarantee period for price match. Tire match price must be determined prior to applying a tire manufacturer rebate, if any. At participating dealers only. Offer ends 12/31/2025.";
export const FIRST_NAME_ERROR = "Please enter valid first name.";
export const LAST_NAME_ERROR = "Please enter valid last name.";
export const EMAIL_ERROR = "Please enter valid email.";
export const NAME_REGEX = '/^[a-zA-Z].{1,30}$/';
export const EMAIL_REGEX = '/^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/';
export const YEARERROR = "Please select a Year from the dropdown.";
export const MAKEERROR = "Please select a Make from the dropdown."
export const MODELERROR = "Please select a Model from the dropdown."
export const TRIMERROR = "Please select a Trim from the dropdown."
export const SIZEERROR = "Please select a Tire Size from the dropdown."
export const ZIP_ERROR = "Please enter a valid zip code."
export const YMM_OSS_STRING ='{BAC}?{makeCode}&vehicle:buy:year={year}&vehicle:buy:make={make}&vehicle:buy:model={model}&origin=TIREFIND&hideReturn=true&'
export const LINE_ITEM = '{quantity} {brand} {name} (PartNumber:{gmPartNum}) for {price}/EA. ';
export const SERVICE_ITEM = '  {serviceName} for {servicePrice}/EA.';